import { render, staticRenderFns } from "./QuestionJourneyTabs.vue?vue&type=template&id=2e7d5378&scoped=true&"
import script from "./QuestionJourneyTabs.vue?vue&type=script&lang=js&"
export * from "./QuestionJourneyTabs.vue?vue&type=script&lang=js&"
import style0 from "./QuestionJourneyTabs.vue?vue&type=style&index=0&id=2e7d5378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d5378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsSlider})
